var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_14708)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0H3.6C1.61178 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61178 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z",
    fill: "#00756A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1441 12.0741C14.6674 11.2726 14.9345 10.5592 14.9245 10.0078C14.9122 9.33099 14.6017 8.82691 14.1445 8.49286C12.7679 7.48936 10.0568 8.02478 10.0937 10.0394C10.1071 10.7996 10.5325 11.7834 11.6386 12.9699C11.6386 12.9699 12.2553 12.4908 12.3906 12.0611C9.45398 8.59821 15.6268 8.40951 12.5558 12.2491C12.5558 12.2491 12.2008 12.7502 11.7489 13.0859C10.7911 13.8694 9.92388 14.1171 9.16773 14.0094C6.54237 13.636 6.12357 10.2368 5.92916 8.21581H4.00154L4 8.28316V8.66088C4.10067 12.6715 7.37152 18.2508 12.5988 13.8624C13.1163 13.4123 13.411 13.0539 13.411 13.0539C13.6764 12.7396 13.9212 12.4123 14.1441 12.0741ZM18.5861 10.3312C18.2338 12.6862 16.6615 14.6758 14.2909 13.5803C14.244 13.6364 14.1951 13.6911 14.1441 13.7444C13.9181 13.9758 13.6635 14.1851 13.3849 14.3685C13.3782 14.3653 13.3711 14.3627 13.3638 14.3608C13.6251 14.5032 13.8856 14.6165 14.1441 14.7029C17.0719 15.6847 19.7426 13.257 20 10.2215L18.6245 10.1681C18.6073 10.2216 18.5945 10.2761 18.5861 10.3312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_14708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkable);
export default __webpack_public_path__ + "static/media/workable.e10009c9c693c14bb279c79c837b4c06.svg";
export { ForwardRef as ReactComponent };